// When the bulletin pops up on its own (the bulletin.autoOpen preference):
// once at login, then at each of these hours of the local day - on weekdays
// only. Holidays still count; only Saturday and Sunday are skipped.
export const BULLETIN_HOURS = [9, 12, 15, 18];

// A slot missed by less than this still fires - a machine that wakes at 9:40
// shows the 9:00 bulletin, one that wakes at 11:00 does not.
export const GRACE_MS = 60 * 60 * 1000;

// Whether the bulletin pops up at all on this day.
export function isScheduleDay(now) {
    const weekday = now.getDay();
    return weekday !== 0 && weekday !== 6;
}

// The most recent slot at or before `now` today, or null before the first.
export function latestSlot(now) {
    let slot = null;
    BULLETIN_HOURS.forEach(hour => {
        const at = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, 0, 0, 0);
        if (at.getTime() <= now.getTime()) {
            slot = {
                key: now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate() + '-' + hour,
                at: at,
            };
        }
    });
    return slot;
}

// The key of the slot that should fire now, or null. Callers remember the
// last key they fired and pass it back, so each slot fires once.
export function dueSlot(now, lastKey) {
    const slot = latestSlot(now);
    if (!slot || slot.key === lastKey || !isScheduleDay(now)) {
        return null;
    }
    return now.getTime() - slot.at.getTime() < GRACE_MS ? slot.key : null;
}

export default { BULLETIN_HOURS, GRACE_MS, isScheduleDay, latestSlot, dueSlot };



// WEBPACK FOOTER //
// ./src/utils/bulletinSchedule.js